<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Semanal Infantil
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
              <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>

          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>

      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.mes_id" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.mesesPlanoSemanal"
                :key="item.id"
                @click="() => loadData(item.id)"
              >
                <v-badge v-if="form.mes_id === item.id" color="success">
                  {{ item.descricao }}
                </v-badge>
                <div v-else>{{ item.descricao }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <v-tabs-items v-model="form.mes_id">
      <v-tab-item v-for="item in $constants.mesesPlanoSemanal" :key="item.id">
        <v-card flat>
          <v-card-text>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form
                @submit.prevent="handleSubmit(createOrUpdate)"
                v-if="loadPlano"
                :disabled="submittingForm"
              >
                <v-row>
                  <v-col cols="6" md="6">
                    <e-label>Escolha a Semana</e-label>
                    <e-autocomplete
                      :items="$constants.semanas"
                      :return-object="false"
                      item-text="descricao"
                      item-value="id"
                      v-model="form.semana_id"
                      label="Escolha a Semana"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="6" md="6">
                    <e-label>Anexar plano</e-label>
                    <div class="dropboxStyles">
                      <v-row>
                        <v-col cols="6">
                          <v-file-input
                            v-model="form.file"
                            accept="application/pdf"
                            dense
                            solo
                            label="Plano semanal"
                            prepend-icon="mdi-file"
                            chip-color="red"
                            @change="onFileSelected($event)"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="3" class="text-right" v-if="form.path">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="downloadPlanoSemanal(item)"
                                class="ml-2"
                                color="red lighten-5"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="red lighten-1" small>fa fa-file-pdf</v-icon>
                                <span class="ml-2">Baixar arquivo</span>
                              </v-btn>
                            </template>
                            <span>Baixar arquivo</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" v-if="form.path">
                          <v-alert dense color="green" icon="mdi-check-circle" text border="left">
                            Enviado: {{ form.path }}
                          </v-alert>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <ValidationProvider
                      name="Objetivos de Aprendizagem e desenvolvimento"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <e-label>OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.objeto_aprendizagem"
                        :error-messages="errors"
                        @input="form.objeto_aprendizagem = form.objeto_aprendizagem.slice(0, 300)"
                      />
                    </ValidationProvider>

                    <ValidationProvider
                      name="O que vamos aprender"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <e-label>O QUE VAMOS APRENDER</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.oque_vamos_aprender"
                        :error-messages="errors"
                        @input="form.oque_vamos_aprender = form.oque_vamos_aprender.slice(0, 300)"
                      />
                    </ValidationProvider>

                    <ValidationProvider
                      name="Metodologia das experiências de aprendizagem"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <e-label>METODOLOGIA DAS EXPERIÊNCIAS DE APRENDIZAGEM</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.medotologia_das_experiencias_de_aprendizagem"
                        :error-messages="errors"
                        @input="
                          form.medotologia_das_experiencias_de_aprendizagem =
                            form.medotologia_das_experiencias_de_aprendizagem.slice(0, 300)
                        "
                      />
                    </ValidationProvider>

                    <ValidationProvider
                      name="Avaliação de desempenho"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <e-label>AVALIAÇÃO DE DESEMPENHO</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.avaliacao_de_desempenho"
                        :error-messages="errors"
                        @input="
                          form.avaliacao_de_desempenho = form.avaliacao_de_desempenho.slice(0, 300)
                        "
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-col cols="12">
                  <v-row>
                    <v-btn
                      color="primary"
                      :disabled="submittingForm"
                      :loading="submittingForm"
                      type="submit"
                    >
                      Enviar Dados
                    </v-btn>
                  </v-row>
                </v-col>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <e-drawer-planos-lancados-semanal
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :mes_id="parseInt(form.mes_id, 10)"
      :semana_id="parseInt(form.semana_id, 10)"
      @planoRestaurado="loadData"
    />
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      habilidade: null,
      experiencia_: null,
      modalDeletarObjetivo: false,
      mensagem: "",
      carregandoHabilidades: false,
      showMessage: false,
      dialog: false,
      search: "",
      submittingForm: false,
      form: {
        mes_id: 0,
        semana_id: null,
        path: "",
        file: null,
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      loadPlano: true,
      semanaSelecionada: null,
    };
  },
  watch: {
    "form.semana_id": function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.loadData();
      }
    },
    "form.mes_id": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadData(newVal);
      }
    },
  },
  methods: {
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      if (
        this.form.semana_id === null ||
        this.form.semana_id === undefined ||
        this.form.semana_id === ""
      ) {
        this.$toast.danger("Por favor, selecione uma semana.");
        return;
      }

      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { mes_id, semana_id } = this.form;

        this.form.mes_id = mes_id;
        this.form.semana_id = semana_id;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;

        await this.$services.planosSemanaisInfantilService.createOrUpdate(this.form);
        this.$toast.success("Plano semanal salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData(id) {
      this.submittingForm = false;
      const { gestaoDeAulaId } = this.$route.params;
      if (id) this.form.mes_id = id;

      try {
        this.$loaderService.open("Carregando dados...");
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        const response = await this.$services.planosSemanaisInfantilService.planoSemanal(
          gestaoDeAulaId,
          this.form.mes_id,
          this.form.semana_id
        );

        if (response && response.plano) {
          this.form = { ...response.plano };
        } else {
          this.form = {
            mes_id: this.form.mes_id,
            semana_id: this.form.semana_id,
            objeto_aprendizagem: "",
            oque_vamos_aprender: "",
            medotologia_das_experiencias_de_aprendizagem: "",
            avaliacao_de_desempenho: "",
          };
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async onFileSelected(file) {
      if (!file) return;

      this.isUploading = true;

      const { gestaoDeAulaId } = this.$route.params;
      const { mes_id, semana_id } = this.form;
      if (
        this.form.semana_id === null ||
        this.form.semana_id === undefined ||
        this.form.semana_id === ""
      ) {
        this.$toast.danger("Por favor, selecione uma semana.");
        return;
      }
      try {
        const response = await this.$services.planosSemanaisInfantilService.planoSemanalPDF(
          gestaoDeAulaId,
          mes_id,
          semana_id,
          file
        );

        this.$set(this.form, "path", response.path);
      } catch (error) {
        this.$toast.danger(error.error || "Erro ao enviar o arquivo.");
        this.$handleError(error);
      } finally {
        this.isUploading = false;
      }
    },

    async downloadPlanoSemanal(semestre) {
      const { gestaoDeAulaId } = this.$route.params;
      const { mes_id, semana_id } = this.form;

      try {
        await this.$services.planosSemanaisInfantilService.downloadPlanoSemanal(
          gestaoDeAulaId,
          mes_id,
          semana_id
        );
      } catch (error) {}
    },
  },
};
</script>

<style></style>
